import { isLocale, type Locale } from '@bb/shared';
import { createFileRoute, notFound } from '@tanstack/react-router';
import { publicEventTypeQuery } from '@/features/public-booking/api';
import { BookingFlow } from '@/features/public-booking/booking-flow';
import { ApiRequestError } from '@/lib/api';
import { ensureNamespace } from '@/lib/i18n';

export const Route = createFileRoute('/$username/$slug')({
  validateSearch: (s: Record<string, unknown>): { lang?: Locale } =>
    isLocale(s.lang) ? { lang: s.lang } : {},
  loader: async ({ context, params }) => {
    await ensureNamespace('booking');
    try {
      return await context.queryClient.ensureQueryData(
        publicEventTypeQuery(params.username, params.slug),
      );
    } catch (err) {
      if (err instanceof ApiRequestError && err.status === 404) throw notFound();
      throw err;
    }
  },
  component: PublicBookingPage,
});

function PublicBookingPage() {
  const { username, slug } = Route.useParams();
  const { host, eventType } = Route.useLoaderData();
  return (
    <main className="mx-auto max-w-3xl px-4 py-6 sm:py-10">
      <BookingFlow
        username={username}
        slug={slug}
        host={host}
        eventType={eventType}
        layout="page"
      />
    </main>
  );
}
